<template>
    <div>
        <div class="row" id="headlines-page">
            <div class="col-lg-6 p-1">
                <div :class="{active: type === 'payment'}" class="card transaction-type p-2" @click="onPaymentClicked">
                    <h3 class="mb-0 text-center" v-if="type === 'payment'">(پرداخت)</h3>
                    <h3 class="mb-0 text-center" v-else>پرداخت</h3>
                </div>
            </div>
            <div class="col-lg-6 p-1">
                <div :class="{active: type === 'receive'}" class="card transaction-type p-2" @click="onReceiveClicked">
                    <h3 class="mb-0 text-center" v-if="type === 'receive'">(دریافت)</h3>
                    <h3 class="mb-0 text-center" v-else>دریافت</h3>
                </div>
            </div>
            <div class="col-lg-12 p-1">
                <div class="card transaction-type p-2 bg-warning" @click="onAccountClicked" v-if="companyType ==='5'">
                    <h3 class="mb-0 text-center">ثبت سند حسابداری با چندین دریافت و پرداخت کننده</h3>

                </div>
            </div>
            <div class="col-lg-2 p-1">
                <div :class="{active: $route.name === 'transaction-bank'}" class="card headline bg-bank p-2" @click="onHeadlineClicked('transaction-bank')">
                    <h4 class="mb-0 text-center text-white">بانک</h4>
                </div>
            </div>
            <div class="col-lg-2 p-1">
                <div :class="{active: $route.name === 'transaction-provider'}" class="card headline bg-provider p-2" @click="onHeadlineClicked('transaction-provider')">
                    <h4 class="mb-0 text-center text-white">تامین کننده</h4>
                </div>
            </div>
            <div class="col-lg-2 p-1">
                <div :class="{active: $route.name === 'transaction-customer'}" class="card headline bg-customer p-2" @click="onHeadlineClicked('transaction-customer')">
                    <h4 class="mb-0 text-center text-white">مشتری</h4>
                </div>
            </div>
            <div class="col-lg-2 p-1">
                <div :class="{active: $route.name === 'transaction-cash-desk'}" class="card headline bg-cash-desk p-2" @click="onHeadlineClicked('transaction-cash-desk')">
                    <h4 class="mb-0 text-center text-white">صندوق</h4>
                </div>
            </div>
            <div class="col-lg-2 p-1">
                <div :class="{active: $route.name === 'transaction-cost'}" class="card headline bg-cost p-2" @click="onHeadlineClicked('transaction-cost')">
                    <h4 class="mb-0 text-center text-white">هزینه</h4>
                </div>
            </div>
            <div class="col-lg-2 p-1">
                <div :class="{active: $route.name === 'transaction-income'}" class="card headline bg-income p-2" @click="onHeadlineClicked('transaction-income')">
                    <h4 class="mb-0 text-center text-white">درآمد</h4>
                </div>
            </div>
            <!--<div class="col-lg-12 mt-3 mb-1" id="headlines">
                <div class="headline-item" @click="onHeadlineClicked('transaction-bank')">
                    <h5>بانک</h5>
                </div>
                <div class="headline-item" @click="onHeadlineClicked('transaction-provider')">
                    <h5>تامین کننده</h5>
                </div>
                <div class="headline-item" @click="onHeadlineClicked('transaction-customer')">
                    <h5>مشتری</h5>
                </div>
                <div class="headline-item" @click="onHeadlineClicked('transaction-cash-desk')">
                    <h5>صندوق</h5>
                </div>
            </div>-->
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
            <div class="sk-circle" id="loading">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import EventBus from '../_framework/event-bus.js';
    import Utils from "../_framework/utils/Utils";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'transactions',
        components: {},
        data() {
            return {
                type: "payment",
                companyType:"",
            }
        },
        mounted() {
            this.companyType = localStorage.getItem("companyType");
            const cc = localStorage.getItem("salemali_close");
            if (cc !== undefined && cc != null && cc === "true") {
                Utils.handleErrorWithNotification("سال مالی بسته شده است و امکان ثبت جدید وجود ندارد", this.$noty);
                this.$router.push({name: 'home'});
            }
            $("#loading").hide();
        },
        methods: {
            onHeadlineClicked(headline) {
                this.$router.push({
                    name: `${headline}`,

                });
            },
            onPaymentClicked() {
                this.type = 'payment';
                EventBus.$emit('transactionType', this.type);
            },
            onReceiveClicked() {
                this.type = 'receive';
                EventBus.$emit('transactionType', this.type);
            },
            onAccountClicked() {
                this.$router.push({
                    name: 'addPayment',

                });
            }
        },
    }
</script>

<style scoped>
    #loading {
        position: absolute;
        top: calc(40% - 40px);
        left: calc(50% - 40px);
    }

    .card.transaction-type {
        /*border-radius: 0.5rem !important;*/
        border: 2px solid #00b8d4;
        transition: all 0.3s;
    }

    .card.transaction-type:hover {
        cursor: pointer;
        background: #eee;
    }

    .card.transaction-type.active {
        /*background: linear-gradient(90deg, #2193b0, #6dd5ed);*/
        background: #00b8d4;
        color: white;
    }

    .card.headline {
        border-radius: 0.25rem;
        border: none;
        text-shadow: 0px 4px 3px rgba(0,0,0,0.4),
        0px 8px 13px rgba(0,0,0,0.1),
        0px 18px 23px rgba(0,0,0,0.1);
    }

    .card.headline:hover {
        cursor: pointer;
    }
</style>